import { useState, useEffect } from "react";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

const images = [
  "/school-logo.png",
  "/person-photo.png",
];

function Introduction() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [isFlipping, setIsFlipping] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsFlipping(true);
      setTimeout(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % images.length);
        setIsFlipping(false);
      }, 300);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <MKBox component="section" py={6}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={6}>
            <MKTypography variant="h3" mb={2} color="dark">
              Welcome to Rose of Sharon Primary School
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={2}>
              Rose of Sharon Primary School is a Christ-centered educational institution committed to 
              providing quality education in a nurturing and safe environment. We believe every child 
              is unique and has the potential to excel academically, spiritually, and socially.
            </MKTypography>
            <MKTypography variant="body1" color="text" mb={2}>
              Our dedicated team of qualified teachers works tirelessly to ensure that each student 
              receives personalized attention and guidance. We combine modern teaching methods with 
              time-tested values to prepare our students for the challenges of tomorrow.
            </MKTypography>
            <MKTypography variant="body1" color="text">
              At Rose of Sharon, we don&apos;t just educate minds – we shape character, build confidence, 
              and inspire a lifelong love for learning grounded in Christian principles.
            </MKTypography>
          </Grid>
          <Grid item xs={12} lg={6}>
            <MKBox
              sx={{
                perspective: "1000px",
                width: "100%",
                height: { xs: 280, lg: 380 },
                padding: { xs: 3, lg: 4 },
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MKBox
                component="img"
                src={images[currentImageIndex]}
                alt="Students in classroom"
                borderRadius="lg"
                shadow="lg"
                sx={{
                  objectFit: "contain",
                  maxWidth: "100%",
                  maxHeight: "100%",
                  padding: { xs: 2, lg: 3 },
                  transform: isFlipping ? "rotateY(90deg)" : "rotateY(0deg)",
                  transition: "transform 0.3s ease-in-out",
                  transformStyle: "preserve-3d",
                }}
              />
            </MKBox>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Introduction;
